import { Mission } from '@/domain/project/Mission';

type MissionsDataSetIndex = 'diffusion' | 'enseignement' | 'collection' | 'expertise' | 'recherche';

interface MissionsDataSetItem {
  value: Mission;
  active: boolean;
}

export interface MissionFilterDataSet {
  diffusion: MissionsDataSetItem;
  enseignement: MissionsDataSetItem;
  collections: MissionsDataSetItem;
  expertise: MissionsDataSetItem;
  recherche: MissionsDataSetItem;
}
export const toMissionFilterDataSet = (missions: Mission[]): MissionFilterDataSet => ({
  diffusion: { value: Mission.DIFFUSION, active: missions.indexOf(Mission.DIFFUSION) > -1 },
  enseignement: { value: Mission.ENSEIGNEMENT, active: missions.indexOf(Mission.ENSEIGNEMENT) > -1 },
  collections: { value: Mission.COLLECTIONS, active: missions.indexOf(Mission.COLLECTIONS) > -1 },
  expertise: { value: Mission.EXPERTISE, active: missions.indexOf(Mission.EXPERTISE) > -1 },
  recherche: { value: Mission.RECHERCHE, active: missions.indexOf(Mission.RECHERCHE) > -1 },
});

export const toMissions = (missionsDataSet: MissionFilterDataSet): Mission[] => {
  return [
    missionsDataSet.diffusion,
    missionsDataSet.enseignement,
    missionsDataSet.collections,
    missionsDataSet.expertise,
    missionsDataSet.recherche,
  ]
    .filter(item => item.active)
    .map(item => item.value);
};
